import { render, staticRenderFns } from "./SwitchList.vue?vue&type=template&id=57665c0d&scoped=true&"
import script from "./SwitchList.vue?vue&type=script&lang=js&"
export * from "./SwitchList.vue?vue&type=script&lang=js&"
import style0 from "./SwitchList.vue?vue&type=style&index=0&id=57665c0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57665c0d",
  null
  
)

export default component.exports